import { Box, Container } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

import { PageContentSidebar } from '#components/page-content-sidebar/page-content-sidebar';
import { PageFooter } from '#components/page-footer/page-footer';
import { PageHeader } from '#components/page-header/page-header';
import { SidebarDrawer } from '#components/sidebar-drawer/sidebar-drawer';

export function Layout() {
  return (
    <Box
      minH="var(--app-viewport-height)"
      h="var(--app-viewport-height)"
      maxH="var(--app-viewport-height)"
      bg="bg.subtle"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      <SidebarDrawer hideFixedToggle />
      <Box flexShrink={0}>
        <PageHeader />
      </Box>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        minHeight={0}
        minWidth={0}
      >
        <Box
          flex={1}
          position="relative"
          display="flex"
          flexDirection="row"
          minHeight={0}
          minWidth={0}
          style={{ backgroundColor: 'var(--surface-app)' }}
        >
          <Box
            flex={1}
            minWidth={0}
            minHeight={0}
            overflowY="auto"
            display="flex"
            flexDirection="column"
          >
            <Container
              maxW="7xl"
              p={0}
              flex={1}
              display="flex"
              flexDirection="column"
              minHeight={0}
              width="100%"
            >
              <Outlet />
            </Container>
          </Box>
          <PageContentSidebar />
        </Box>
      </Box>
      <PageFooter />
    </Box>
  );
}
